module.exports = __webpack_public_path__ + "media/img/partner-8-43ae5de3.png";